<template>
    <div class='companylist'>
        <div class='cont'>
            <div class="selectCont">
                <div class="addbtn" @click="addzw()"><i class="el-icon-circle-plus-outline"></i>添加客户</div>
                <div v-bind:class="item.id === setid ? 'resitem resitemactive' : 'resitem'" v-for="item in companylist"
                    :key="item.id" @click="getResInfo(item.id)">
                    <el-image class="avatersss" size="medium" :src="item.customCompanyLogo" fit="cover"></el-image>
                    <div class="p1">{{ item.customCompanyFullName }}</div>
                </div>
            </div>

            <div v-if="setitem" class="tableCont" v-loading="loading" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0)">

                <div class="topbtnbox">
                    <div class="editbtn" @click="goPost()"><i class="el-icon-s-unfold"></i>发布职位</div>
                    <div class="editbtn" @click="editzw()"><i class="el-icon-edit"></i>编辑</div>
                    <el-popconfirm confirm-button-text='确定' cancel-button-text='不用了' icon="el-icon-info" icon-color="red"
                        title="是否删除该职位" @confirm="delzw()">
                        <el-button class="delbtn" slot="reference"><i class="el-icon-delete"></i>删除</el-button>
                    </el-popconfirm>
                </div>



                <el-image class="avaters"
                    v-if="setitem.customCompanyLogo && setitem.customCompanyLogo.indexOf('https://images.qilinpin.cn/') >= 0"
                    fit="cover" size="large" :src="setitem.customCompanyLogo"></el-image>
                <div class="name">{{ setitem.customCompanyFullName }}</div>
                <div class="tagbox">
                    <el-tag>{{ setitem.customCompanyNature }}</el-tag>
                    <el-tag type="success">{{ setitem.industry }}</el-tag>
                    <el-tag type="info">{{ setitem.inTheCity }}</el-tag>
                    <el-tag type="warning">{{ setitem.staffSize }}</el-tag>
                    <el-tag type="danger">{{ setitem.financingStage }}</el-tag>
                </div>
                <div class="gstjbox" v-if="gstj">
                    <div class="gstj">推面率: {{ gstj.pushfaceRate }} %</div>
                    <div class="gstj">面试数: {{ gstj.anoralquizNum }}</div>
                    <div class="gstj">offer数量: {{ gstj.offerNum }}</div>
                    <div class="gstj">offer率: {{ gstj.offerRate }} %</div>
                    <div class="gstj">推荐数: {{ gstj.recommendNum }}</div>
                </div>
                <div class="bt">
                    公司公告
                    <div class="btn" @click="passortg2()">添加公告</div>
                </div>
                <div class="fkBox">
                    <div class="tip" v-if="gglist.length <= 0">当前暂无公司公告</div>
                    <div class="tipbox" v-for="(item, index) in gglist" :key="index">
                        <div class="boxbottom">
                            {{ item.notice }}
                        </div>
                        <div class="boxtop">
                            <div class="topp1" @click="passortg1(item)">编辑</div>
                            <div class="topp2 close" @click="deletegg(item.id)">删除</div>
                        </div>
                    </div>
                </div>
                <div class="bt">
                    公司简介
                </div>
                <div class="btcont" v-html="setitem.describes">

                </div>
                <div class="bt">
                    公司分析
                </div>
                <div class="btcont" v-html="setitem.analysis">

                </div>
            </div>

        </div>
        <el-dialog :title="form1.title" :visible.sync="dialogFormVisible1">
            <el-form :model="form1">
                <el-form-item :label="form1.par" :label-width="formLabelWidth">
                    <el-input v-model="form1.notice" autocomplete="off" :placeholder="'请输入' + form1.par"></el-input>
                </el-form-item>
                <el-form-item label="是否置顶" :label-width="formLabelWidth">
                    <el-radio-group v-model="form1.isTop">
                        <el-radio label="1">置顶</el-radio>
                        <el-radio label="0">不置顶</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="form1.title === '添加公告' ? addgg() : editgg()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="form2.title" :visible.sync="dialogFormVisible2">
            <el-form :model="form2">
                <el-form-item label="*企业全称" :label-width="formLabelWidth">
                    <el-input v-model="form2.customCompanyFullName"></el-input>
                </el-form-item>
                <el-form-item label="*企业简称" :label-width="formLabelWidth">
                    <el-input v-model="form2.customCompanyName"></el-input>
                </el-form-item>
                <el-form-item label="企业地址类型" :label-width="formLabelWidth">
                    <el-radio-group v-model="addressType" size="mini">
                        <el-radio label="1" border>国内地址</el-radio>
                        <el-radio label="2" border>国外地址</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="*企业地址" :label-width="formLabelWidth" v-if="Number(addressType) === 1">
                    <el-select style="width: 400px" v-model="form2.detailedAddress" clearable filterable remote
                        reserve-keyword placeholder="请输入地点进行搜索" :remote-method="getSearchSuggestion"
                        :loading="searchloading" @clear="searchClear" @change="searchChange">
                        <el-option v-for="item in searchSuggestion" :key="item.id"
                            :label="item.address + '(' + item.title + ')'" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="*企业地址（国外）" :label-width="formLabelWidth" v-if="Number(addressType) === 2">
                    <el-input v-model="form2.detailedAddress"></el-input>
                </el-form-item>
                <el-form-item label="*企业所在城市" :label-width="formLabelWidth">
                    <el-input v-model="form2.inTheCity"></el-input>
                </el-form-item>
                <el-form-item label="企业官网" :label-width="formLabelWidth">
                    <el-input v-model="form2.customCompanyWeb"></el-input>
                </el-form-item>
                <el-form-item label="*企业性质" :label-width="formLabelWidth">
                    <el-select v-model="form2.customCompanyNature" placeholder="请选择企业性质">
                        <el-option :label="item" v-for="(item, index) in NatureSelector" :key="index"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="*所属行业" :label-width="formLabelWidth">
                    <el-select v-model="form2.industry" placeholder="请选择所属行业">
                        <el-option :label="item.value" v-for="(item, index) in industrySelector" :key="index"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="*融资阶段" :label-width="formLabelWidth">
                    <el-select v-model="form2.financingStage" placeholder="请选择融资阶段">
                        <el-option :label="item" v-for="(item, index) in financingStageSelector" :key="index"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="*人员规模" :label-width="formLabelWidth">
                    <el-select v-model="form2.staffSize" placeholder="请选择人员规模">
                        <el-option :label="item" v-for="(item, index) in companyPeopleNumberSelector" :key="index"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="*公司logo" :label-width="formLabelWidth">
                    <el-upload :show-file-list="false" :key="setid" class="avatar-uploader" drag action="1"
                        :on-change="setFile" :auto-upload="false" :limit="1" :on-remove="remove" ref="upload">
                        <el-image fit="cover"
                            v-if="customCompanyLogo && customCompanyLogo.indexOf('https://images.qilinpin.cn/') >= 0"
                            :src="customCompanyLogo" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <my-cropper ref="myCropper" @getFile="getFile" @upAgain="upAgain" @closeUp="closeUp"></my-cropper>
                </el-form-item>
                <el-form-item label="公司简介" :label-width="formLabelWidth">
                    <div>
                        <editor v-model="describes" ref="myEditor" key="0"></editor>
                    </div>
                </el-form-item>
                <el-form-item label="公司分析" :label-width="formLabelWidth">
                    <div>
                        <editor2 v-model="analysis" ref="myEditor1" key="1"></editor2>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                <el-button type="primary" @click="form2.title === '编辑客户公司信息' ? saveCompany() : addCompany()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import Config from '../config/index'
import OSS from 'ali-oss'
import qs from 'qs'
import MyCropper from "./cropper.vue"
import editor from '@/components/QuillEditor.vue'
import editor2 from '@/components/QuillEditor.vue'
let client = new OSS({
    region: 'oss-cn-beijing',
    accessKeySecret: 'mPTRYqVIIWC8XxSeZqKFMPtFMWMfb5', // AccessKeySecret 去你的阿里云上控制台上找
    accessKeyId: 'LTAIvBaMapD5qPW9', // AccessKeyId 去你的阿里云上控制台上找
    bucket: 'linkedln',
    endpoint: 'images.qilinpin.cn',
    cname: true,
    secure: true
})

export default {
    name: 'companylist',
    props: {},
    components: { MyCropper, editor, editor2 },
    data() {
        return {
            userStatus: this.$store.state.userStatus,
            cjFile: false,
            industrySelector: [],
            companylist: [],
            searchloading: false,
            gglist: [],
            gstj: false,
            moment: moment,
            jobName: '全部职位',
            jobPageNum: 1,
            jobPageSize: 200,
            jobList: [],
            resumeStatus: '1',
            resumeList: [],
            resumePageNum: 1,
            resumePageSize: 11,
            resumePageTotle: 0,
            searchSuggestion: [],
            loading: false,
            setitem: false,
            setid: false,
            dialogFormVisible: false,
            dialogFormVisible1: false,
            dialogFormVisible2: false,
            file: false,
            fileUrl: '',
            NatureSelector: ['国有企业', '集体所有制企业', '私营企业', '股份制企业', '有限合伙企业', '联营企业', '外商投资企业', '个人独资企业', '外资企业'],
            financingStageSelector: ['未融资', '种子轮', '天使轮', 'A轮', 'B轮', 'C轮', 'D轮及以上', '上市公司', '不需要融资'],
            companyPeopleNumberSelector: ['50人以下', '50-59人', '100-499人', '500-999人', '1000-9999人', '10000人以上'],
            customCompanyLogo: '',
            form1: {
                title: '',
                par: '',
                notice: '',
                isTop: '0',
                id: ''
            },
            form2: {
                title: '',
                companyId: '',
                userId: '',
                customCompanyFullName: '',
                customCompanyWeb: '',
                customCompanyName: '',
                detailedAddress: '',
                inTheCity: '',
                customCompanyNature: '',
                financingStage: '',
                staffSize: '',
                industry: ''
            },
            formLabelWidth: '120px',
            mwidth: {
                '1': '75px',
                '2': '225px',
                '3': '375px',
                '4': '525px',
                '5': '675px',
                '6': '825px',
                '7': '910px',
                '99': '75px'
            },
            addressType: '1',
            describes: '',
            analysis: ''
        }
    },
    watch: {},
    created: function () { },
    methods: {
        closeUp() {
            debugger
            this.$refs.upload.clearFiles()//清空上传列表
        },
        upAgain() {

            this.$refs.upload.clearFiles()//清空上传列表
            this.$refs['upload'].$refs["upload-inner"].handleClick();
        },

        getFile(file) {
            let that = this
            const formData = new FormData();
            formData.append("file", file)
            that.file = file
            that.uplaod()
        },
        goPost: function () {
            this.$router.push({
                path: '/newPost',
            })
        },
        saveCompany: function () {
            let that = this
            if (this.form2.customCompanyFullName === '' || this.form2.customCompanyFullName === undefined) {
                that.$message.error('请输入您公司的名称');
                return false
            }
            if (this.form2.inTheCity === '' || this.form2.inTheCity === undefined) {
                that.$message.error('请输入您公司的所在城市');
                return false
            }
            if (this.form2.customCompanyName === '' || this.form2.customCompanyName === undefined) {
                that.$message.error('请输入您公司的简称');
                return false
            }
            if (this.form2.detailedAddress === '' || this.form2.detailedAddress === undefined) {
                that.$message.error('请输入您的公司所在地址');
                return false
            }
            if (this.customCompanyLogo.indexOf('https://images.qilinpin.cn/') < 0) {
                that.$message.error('请上传您的公司Logo');
                return false
            }

            let sst1 = this.$refs.myEditor.quill.container.querySelector('.ql-editor').innerHTML
            let sst2 = this.$refs.myEditor1.quill.container.querySelector('.ql-editor').innerHTML

            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/custom/company/edit',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    id: this.setid,
                    companyId: this.userStatus.companyId,
                    userId: this.userStatus.id,
                    customCompanyFullName: this.form2.customCompanyFullName,
                    customCompanyWeb: this.form2.customCompanyWeb,
                    customCompanyName: this.form2.customCompanyName,
                    detailedAddress: this.form2.detailedAddress.value ? this.form2.detailedAddress.value : this.form2.detailedAddress,
                    inTheCity: this.form2.inTheCity,
                    customCompanyNature: this.form2.customCompanyNature,
                    financingStage: this.form2.financingStage,
                    staffSize: this.form2.staffSize,
                    industry: this.form2.industry,
                    customCompanyLogo: this.customCompanyLogo,
                    describes: sst1,
                    analysis: sst2
                }
            }).then((res) => {
                if (res.data.success === '1') {
                    that.getResInfo(that.setid)
                    that.getTopList('no')
                    that.dialogFormVisible2 = false
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        getIp: function () {
            let that = this

            this.$jsonp('https://apis.map.qq.com/ws/location/v1/ip', {
                key: 'HTEBZ-R2RWW-32VR6-RZGNC-TV5M5-LPBNI',
                ip: '220.249.55.194',
                output: 'jsonp',
            })
                .then((res) => {
                    if (res.status === 0) {
                        this.seacherregion = res.result.ad_info.city
                    } else {
                        this.seacherregion = '北京市'
                    }
                })
                .catch((err) => {
                    that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                })
        },

        getSearchSuggestion: function (e) {
            let that = this
            that.searchloading = true

            this.$jsonp('https://apis.map.qq.com/ws/place/v1/suggestion', {
                keyword: e,
                region: this.seacherregion,
                region_fix: 0,
                key: 'HTEBZ-R2RWW-32VR6-RZGNC-TV5M5-LPBNI',
                output: 'jsonp',
            })
                .then((res) => {
                    that.searchloading = false
                    if (res.status === 0) {
                        for (let i in res.data) {
                            res.data[i].value =
                                res.data[i].address + '(' + res.data[i].title + ')'
                            res.data[i].label =
                                res.data[i].address + '(' + res.data[i].title + ')'
                        }
                        that.searchSuggestion = res.data
                    }
                })
                .catch((err) => {
                    that.searchloading = false
                    that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                })
        },

        searchClear: function () {
            this.searchaddres = ''
            this.searchloading = false
            this.searchSuggestion = []
        },

        searchChange: function (e) {
            this.form2.inTheCity = e.city
        },
        addCompany: function () {
            let that = this
            if (this.form2.customCompanyFullName === '' || this.form2.customCompanyFullName === undefined) {
                that.$message.error('请输入您公司的名称');
                return false
            }
            if (this.form2.inTheCity === '' || this.form2.inTheCity === undefined) {
                that.$message.error('请输入您公司的所在城市');
                return false
            }
            if (this.form2.customCompanyName === '' || this.form2.customCompanyName === undefined) {
                that.$message.error('请输入您公司的简称');
                return false
            }
            if (this.form2.detailedAddress === '' || this.form2.detailedAddress === undefined) {
                that.$message.error('请输入您的公司所在地址');
                return false
            }
            if (this.customCompanyLogo.indexOf('https://images.qilinpin.cn/') < 0) {
                that.$message.error('请上传您的公司Logo');
                return false
            }

            let sst1 = this.$refs.myEditor.quill.container.querySelector('.ql-editor').innerHTML
            let sst2 = this.$refs.myEditor1.quill.container.querySelector('.ql-editor').innerHTML


            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/custom/company/add',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    companyId: this.userStatus.companyId,
                    userId: this.userStatus.id,
                    customCompanyFullName: this.form2.customCompanyFullName,
                    customCompanyWeb: this.form2.customCompanyWeb,
                    customCompanyName: this.form2.customCompanyName,
                    detailedAddress: this.form2.detailedAddress.value,
                    inTheCity: this.form2.inTheCity,
                    customCompanyNature: this.form2.customCompanyNature,
                    financingStage: this.form2.financingStage,
                    staffSize: this.form2.staffSize,
                    industry: this.form2.industry,
                    customCompanyLogo: this.customCompanyLogo,
                    describes: sst1,
                    analysis: sst2
                }
            }).then((res) => {
                if (res.data.success === '1') {
                    that.getTopList('yes')
                    that.dialogFormVisible2 = false
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        editzw: function () {
            let that = this
            this.form2 = {
                title: '编辑客户公司信息',
                companyId: this.setitem.companyId,
                userId: this.userStatus.id,
                customCompanyFullName: this.setitem.customCompanyFullName,
                customCompanyWeb: this.setitem.customCompanyWeb,
                customCompanyName: this.setitem.customCompanyName,
                detailedAddress: this.setitem.detailedAddress,
                inTheCity: this.setitem.inTheCity,
                customCompanyNature: this.setitem.customCompanyNature,
                financingStage: this.setitem.financingStage,
                staffSize: this.setitem.staffSize,
                industry: this.setitem.industry
            }
            this.describes = this.setitem.describes
            this.analysis = this.setitem.analysis
            this.file = false
            this.customCompanyLogo = this.setitem.customCompanyLogo
            this.dialogFormVisible2 = true
            setTimeout(()=>{
                debugger
                that.$refs.myEditor.quill.container.querySelector('.ql-editor').innerHTML = that.setitem.describes
                debugger
                that.$refs.myEditor1.quill.container.querySelector('.ql-editor').innerHTML = that.setitem.analysis
            },1000)
            

        },
        addzw: function () {
            this.form2 = {
                title: '添加新的客户公司信息',
                companyId: this.userStatus.companyId,
                userId: this.userStatus.id,
                customCompanyFullName: '',
                customCompanyWeb: '',
                customCompanyName: '',
                detailedAddress: '',
                inTheCity: '',
                customCompanyNature: this.NatureSelector[0],
                financingStage: this.financingStageSelector[0],
                staffSize: this.companyPeopleNumberSelector[0],
                industry: this.industrySelector[0].value
            }
            this.describes = ''
            this.analysis = ''
            this.file = false
            this.customCompanyLogo = ''
            this.dialogFormVisible2 = true
            setTimeout(()=>{
                debugger
                that.$refs.myEditor.quill.container.querySelector('.ql-editor').innerHTML = ''
                debugger
                that.$refs.myEditor1.quill.container.querySelector('.ql-editor').innerHTML = ''
            },1000)
        },
        getHyList: function () {
            let that = this
            axios({
                method: 'GET',
                url: Config.path + '/api/common/dict/getDictlist?type=jobType',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                }
            }).then((res) => {
                if (res.data.success === '1') {
                    that.industrySelector = res.data.content
                    that.industry = res.data.content[0].value
                    that.industryCode = res.data.content[0].code
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        delzw: function () {

            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/custom/company/del',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    id: this.setid
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.setitem = false
                    that.getTopList()
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        getTopList: function (type = 'yes') {
            let that = this
            let data = {
                pageNum: that.jobPageNum,
                pageSize: that.jobPageSize,
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/custom/company/getList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: data,
            }).then((res) => {
                if (res.data.success === '1') {
                    let demoList = res.data.content.list
                    that.companylist = demoList
                    if (demoList.length > 0 && type === 'yes') {
                        that.getResInfo(demoList[0].id)
                    }
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        remove: function () {
            this.file = false
        },
        setFile: function (res) {
            debugger
            let that = this
            let file = res.raw
            this.$nextTick(() => {
                this.$refs.myCropper.open(file.raw || file)
            })
            // this.limitFileWH(400, 400, file).then((res) => {
            //      
            //     file.isFlag = res
            //     if (file.isFlag) {
            //         that.file = res.file
            //         that.uplaod()
            //         return resolve(true)
            //     } else {
            //          
            //         that.$refs.upload.clearFiles()//清空上传列表
            //         that.file = false
            //         return reject(false)
            //     }
            // })
        },
        limitFileWH(E_width, E_height, file) {
            const _this = this
            let imgWidth = ''
            let imgHight = ''
            const isSize = new Promise(function (resolve, reject) {
                const width = E_width
                const height = E_height
                const _URL = window.URL || window.webkitURL
                const img = new Image()
                img.onload = function () {
                    imgWidth = img.width
                    imgHight = img.height
                    const valid = img.width / img.height < 1.2 && img.width / img.height > 0.8
                    valid ? resolve() : reject()
                }
                img.src = _URL.createObjectURL(file)
            }).then(() => {
                return true
            }, () => {
                _this.$message.warning({
                    message: '上传的图片长宽比应为0.8~1.2之间,尽量为正方形',
                    btn: false
                })
                return false
            })
            return isSize
        },
        uplaod: function (res) {
            let that = this
            let str = this.random_string(32)
            client.multipartUpload('upload/' + str + '.png', this.file, {
                progress: function (p) {
                    that.loading = true;
                    console.log('Progress: ' + p);
                    that.p = p
                }
            }).then((res) => {

                that.loading = false
                console.log(res)
                that.$refs.myCropper.close()
                that.customCompanyLogo = 'https://images.qilinpin.cn/' + res.name
            }).catch((err) => {

                that.loading = false
                console.log(err);
            });
        },
        random_string: function (len) {
            len = len || 32
            var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
            var maxPos = chars.length
            var pwd = ''
            for (let i = 0; i < len; i++) {
                pwd += chars.charAt(Math.floor(Math.random() * maxPos))
            }
            return pwd
        },
        random_number: function (len) {
            len = len || 32
            var chars = '123456789'
            var maxPos = chars.length
            var pwd = ''
            for (let i = 0; i < len; i++) {
                pwd += chars.charAt(Math.floor(Math.random() * maxPos))
            }
            return pwd
        },
        passortg(type) {
            this.form = {
                statusDes: '',
                statusOp: type,
                status: type === 1 ? 2 : 4,
                title: type === 1 ? '淘汰简历' : '通过简历',
                par: type === 1 ? '淘汰理由' : '通过理由'
            }
            this.dialogFormVisible = true
        },
        passortg1(item) {
            this.form1 = {
                title: '编辑公告',
                par: '公司公告',
                notice: item.notice,
                isTop: item.isTop,
                id: item.id
            }
            this.dialogFormVisible1 = true
        },
        passortg2(item) {
            this.form1 = {
                title: '添加公告',
                par: '公司公告',
                notice: '',
                isTop: '0',
                id: ''
            }
            this.dialogFormVisible1 = true
        },
        getResInfo: function (id) {
            let that = this
            that.setid = id
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/custom/company/get',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    id: id
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.gstj = false
                    that.setitem = res.data.content
                    that.getgsGg(id)
                    that.getgstj(id)
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        getJobInfo: function (id) {
            let that = this
            that.setid = id
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/custom/company/get',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    id: id
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.gstj = false
                    that.setitem = res.data.content
                    that.getgsGg(id)
                    that.getgstj(id)
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        getgsGg(id) {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/custom/company/notice/getList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    customCompanyid: id
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.gglist = res.data.content
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        getgstj(id) {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/custom/company/getStatistics',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    id: id
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.gstj = res.data.content
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        editgg() {
            let that = this
            let id = this.setid
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/custom/company/notice/edit',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    customCompanyId: id,
                    notice: this.form1.notice,
                    isTop: this.form1.isTop,
                    id: this.form1.id
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.getgsGg(id)
                    that.dialogFormVisible1 = false
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        addgg() {
            let that = this
            let id = this.setid
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/custom/company/notice/add',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    customCompanyId: id,
                    notice: this.form1.notice,
                    isTop: this.form1.isTop
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.getgsGg(id)
                    that.dialogFormVisible1 = false
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        deletegg(id) {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/custom/company/notice/del',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    id: id
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.getgsGg(that.setid)
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        passRes() {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/resume/flagStatus',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    candidateId: that.setid,
                    status: that.form.status,
                    statusDes: that.form.statusDes,
                    statusOp: that.form.statusOp,
                },
            }).then((res) => {
                that.dialogFormVisible = false
                if (res.data.success === '1' || res.data.success === '01') {
                    that.getResInfo(that.setid)
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        flag(num) {
            let that = this
            if ((num === 2 && this.setitem.status === 1) || (num === 3 && this.setitem.status === 2) || (num === 5 && this.setitem.status === 4) || (num === 6 && this.setitem.status === 5) || (num === 7 && this.setitem.status === 6) || (num === 99)) {
            } else {
                return false
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/resume/flagStatus',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    candidateId: that.setid,
                    status: num,
                    statusDes: '',
                    statusOp: 0
                },
            }).then((res) => {
                if (res.data.success === '1' || res.data.success === '01') {
                    that.getResInfo(that.setid)
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        getResumeList: function () {
            let that = this
            that.loading = true;
            let data = {
                pageNum: that.resumePageNum,
                pageSize: that.resumePageSize,
                status: Number(that.resumeStatus)
            }
            if (that.jobName !== '' && that.jobName !== 'all' && that.jobName !== '全部职位') {
                data.jobId = that.jobName
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/resume/getJobResume',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: data,
            }).then((res) => {
                that.loading = false;
                if (res.data.success === '1') {
                    for (let i = 0; i < res.data.content.list.length; i++) {
                        res.data.content.list[i].visible2 = false
                        res.data.content.list[i].visible3 = false
                        res.data.content.list[i].visible4 = false
                        res.data.content.list[i].xsTime = moment(res.data.content.list[i].createTime).format('YYYY-MM-DD HH:mm:ss')
                    }
                    that.resumeList = res.data.content.list
                    that.resumePageTotle = res.data.content.total
                    if (res.data.content.list.length > 0) {
                        that.getResInfo(res.data.content.list[0].id)
                    }
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.loading = false;
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        selectJob: function (e) {
            this.jobName = e
            this.resumePageNum = 1
            this.getResumeList()
        },
        changeResumeStatus: function (e) {
            this.resumeStatus = e
            this.resumePageNum = 1
            this.getResumeList()
        },
        handleCurrentChange: function (e) {
            this.resumePageNum = e
            this.getResumeList()
        },
        openPdf: function (url) {
            window.open(url, "_blank");
        },
        lookPhone: function (item) {
            if (Number(item.isContactInformation) === 1) {
                this.$alert('候选人' + item.name + '联系方式：' + item.phone, '提示', {
                    confirmButtonText: '确定',
                });
                return false
            }
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/resume/getResumeLink',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    candidateId: item.id
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    this.$alert('候选人' + item.name + '联系方式：' + item.phone, '提示', {
                        confirmButtonText: '确定',
                    });
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        popover: function (index, flag, status) {
            let list = this.resumeList
            list[index]['visible' + flag] = false
            if (status) {
                this.flagResume(index, flag)
            }
        },
        flagResume: function (index, flag) {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/resume/flagStatus',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    candidateId: this.resumeList[index].id,
                    resumeEnterpriseStatus: flag
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.resumeList[index].entryPersonStatus = flag
                }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        }
    },
    mounted: function () {
        this.getTopList()
        this.getHyList()
        this.getIp()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.companylist {
    min-width: 100vw;
    flex: 1;
    padding-top: 1px;
    position: relative;
    background-color: #e6e6e6;


    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        width: 178px;
        height: 178px;

        .el-upload-dragger {
            width: 178px;
            height: 178px;
        }
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }



    .paginationBox {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 100px;
        left: 50%;
        transform: translateX(-50%);
        background-color: #ffffff;
        width: max-content;
        padding: 5px 40px;
        z-index: 9999;
        border-radius: 10px;

        .el-pager {
            li {
                background: transparent;
                color: #5DC2D0;
            }

            .active {
                background: #fff;
                color: #5DC2D0;
            }
        }

        .el-pagination .btn-prev,
        .el-pagination .btn-next {
            background-color: transparent;

            i {
                color: #ffffff;
            }
        }
    }

    .cont {
        width: 100vw;
        overflow-x: scroll;
        height: calc(100%);
        border-radius: 8px;
        box-sizing: border-box;
        // overflow: hidden;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;

        .selectCont {
            width: 311px;
            background-color: #ffffff;
            box-sizing: border-box;
            margin-top: 30px;
            padding: 35px 22px;
            border-radius: 10px;
            margin-left: 20px;



            .addbtn {
                background-color: #5dc1cf;
                color: #fff;
                margin-right: 20px;
                width: 262px;
                height: 40px;
                border-radius: 5px;
                line-height: 40px;
                text-align: center;
                margin-bottom: 20px;
                cursor: pointer;

                i {
                    margin-right: 5px;
                }
            }


            .resitem {
                width: 262px;
                height: 77px;
                border-radius: 10px;
                border: 1px solid #5dc1cf;
                padding: 10px;
                box-sizing: border-box;
                margin-bottom: 10px;
                cursor: pointer;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                .p1 {
                    font-size: 18px;
                    color: #5dc1cf;
                }

                .avatersss {
                    width: 50px;
                    height: 50px;
                    border-radius: 100%;
                }

            }

            .resitemactive {
                background-color: #5dc1cf;

                .p1 {
                    font-size: 18px;
                    color: #ffffff;
                }

                .p2 {
                    font-size: 12px;
                    color: #ffffff;
                }

                .p3 {
                    font-size: 12px;
                    color: #ffffff;
                }
            }
        }

        .tableCont {
            flex: 0.9;
            margin-top: 30px;
            box-sizing: border-box;
            background-color: #ffffff;
            margin-right: 20px;
            border-radius: 10px;
            padding: 30px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            overflow-x: scroll;

            .topbtnbox {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-end;
                width: 90%;

                .editbtn {
                    background-color: #5dc1cf;
                    color: #fff;
                    margin-right: 20px;
                    width: 100px;
                    height: 40px;
                    border-radius: 5px;
                    line-height: 40px;
                    text-align: center;
                    cursor: pointer;

                    i {
                        margin-right: 5px;
                    }
                }

                .delbtn {
                    background-color: red;
                    color: #fff;
                    margin-right: 20px;
                    width: 100px;
                    height: 40px;
                    border-radius: 5px;
                    text-align: center;
                    cursor: pointer;

                    i {
                        margin-right: 5px;
                    }
                }
            }


            .avaters {
                width: 150px;
                height: 150px;
                border-radius: 100%;
            }

            .name {
                color: #4d4848;
                width: fit-content;
                margin-top: 20px;
            }

            .tagbox {
                margin-top: 20px;

                .el-tag {
                    margin: 0 10px;
                }
            }

            .gstjbox {
                margin-top: 30px;
                display: flex;
                width: 610px;
                flex-direction: row;
                justify-content: space-around;
                align-items: center;

                .gstj {
                    color: #8c939d;
                }
            }

            .btcont{
                width: 90%;
                margin: 0 auto;
            }

            .bt {
                width: 90%;
                font-size: 20px;
                font-weight: bold;
                padding-left: 20px;
                height: 26px;
                line-height: 26px;
                border-left: 5px solid #5dc1cf;
                margin-bottom: 30px;
                margin-top: 30px;
                position: relative;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .btn {
                    cursor: pointer;
                    width: 120px;
                    height: 36px;
                    font-size: 18px;
                    line-height: 36px;
                    border-radius: 36px;
                    background-color: #5dc1cf;
                    color: #ffffff;
                    text-align: center;
                }
            }

            .fkBox {
                width: 90%;
                padding: 30px;
                box-sizing: border-box;
                border-radius: 10px;
                background-color: #c0ac584d;
                margin: 30px auto;



                .title {
                    color: #4d4d4d;
                    font-weight: bold;
                    margin-bottom: 10px;
                }

                .tip {
                    color: #4d4d4d;
                }

                .tipbox {
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    margin: 0px 0 30px 0;

                    .boxtop {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: flex-start;
                        width: 100%;

                        .topp1 {
                            color: #4d4d4d;
                            font-size: 18px;
                            font-weight: bold;
                            margin-right: 20px;
                            cursor: pointer;
                        }

                        .topp2 {
                            color: #4d4d4d;
                            font-size: 18px;
                            font-weight: bold;
                            cursor: pointer;
                        }

                        .close {
                            color: red;
                        }

                        .pass {
                            color: green;
                        }
                    }

                    .boxbottom {
                        margin-bottom: 20px;
                        color: #4d4d4d;
                    }
                }
            }
        }


    }
}
</style>
